import React from "react";
import NotificationPopup from "./NotificationPopup.js";
import { isBrowser } from "react-device-detect";

const ConfirmPopup = ({ open, onCancel, onConfirm, message, type = "success", iconSrc = "assets/icons/greencheck.svg", buttonLabelText = "Cancel", proceedButtonLabelText = "Confirm" }) => (
  <NotificationPopup
    open={open}
    onClose={onCancel}
    title={isBrowser ? "Notification" : undefined}
    message={message}
    iconSrc={isBrowser ? iconSrc : undefined}
    buttonLabel={buttonLabelText}
    onProceed={onConfirm}
    proceedButtonLabel={proceedButtonLabelText}
    variant={isBrowser ? type : "secondary"}
  />
);

export default ConfirmPopup;
